import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Shield, CheckCircle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ConsensoPrivacy({ onAccept }) {
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [saving, setSaving] = useState(false);

  const bothChecked = check1 && check2;

  const handleAccept = async () => {
    if (!bothChecked) return;
    setSaving(true);
    try {
      await axios.post(`${API}/auth/accetta-privacy`, {});
      onAccept();
    } catch (e) { console.error(e); }
    setSaving(false);
  };

  return (
    <div className="min-h-screen bg-[#0f1d32] flex items-center justify-center px-4">
      <div className="w-full max-w-xl">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#C9A84C]/15 border border-[#C9A84C]/25 flex items-center justify-center mx-auto mb-4">
            <Shield className="w-7 h-7 text-[#C9A84C]" />
          </div>
          <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Autorizzazione all'accesso dell'Area Riservata
          </h1>
          <p className="text-sm text-white/40 mt-1">UGL - Unione Zonale Lariano</p>
        </div>

        <div className="bg-[#13243d] border border-[#1e3456] rounded-xl p-6">
          <div className="max-h-[45vh] overflow-y-auto mb-6 pr-2 space-y-4 text-sm text-white/60 leading-relaxed">
            <p>
              L'area riservata consente la gestione del profilo utente, la consultazione dei servizi disponibili, 
              la ricezione di comunicazioni dedicate e, ove previsto, la conservazione e consultazione della 
              documentazione caricata nel proprio spazio personale.
            </p>

            <p>
              Per accedere è necessario prendere visione dell'informativa relativa al trattamento dei dati personali 
              da parte di <strong className="text-white/80">UGL - Unione Zonale Lariano</strong>, effettuato per finalità organizzative, 
              amministrative e di erogazione dei servizi richiesti.
            </p>

            <p>
              Il sistema adotta misure di sicurezza per la protezione degli accessi e dei dati trattati. 
              Eventuali trasferimenti di dati connessi ai servizi tecnologici utilizzati dal portale avvengono 
              secondo le modalità e le garanzie indicate nell'informativa privacy.
            </p>
          </div>

          {/* Checkbox 1 */}
          <label className="flex items-start gap-3 cursor-pointer mb-3 p-3 rounded-lg border border-[#1e3456] hover:border-[#C9A84C]/30 transition-colors" data-testid="privacy-checkbox1-label">
            <input type="checkbox" checked={check1} onChange={e => setCheck1(e.target.checked)}
              className="mt-0.5 w-4 h-4 rounded border-white/20 accent-[#C9A84C]" data-testid="privacy-checkbox" />
            <span className="text-sm text-white/70">
              Confermo di aver letto l'<Link to="/privacy" target="_blank" className="text-[#00A0D1] hover:underline">Informativa Privacy</Link>
            </span>
          </label>

          {/* Checkbox 2 */}
          <label className="flex items-start gap-3 cursor-pointer mb-5 p-3 rounded-lg border border-[#1e3456] hover:border-[#C9A84C]/30 transition-colors" data-testid="privacy-checkbox2-label">
            <input type="checkbox" checked={check2} onChange={e => setCheck2(e.target.checked)}
              className="mt-0.5 w-4 h-4 rounded border-white/20 accent-[#C9A84C]" data-testid="privacy-checkbox2" />
            <span className="text-sm text-white/70">
              Confermo di voler accedere e utilizzare l'area riservata secondo le condizioni previste
            </span>
          </label>

          <Button onClick={handleAccept} disabled={!bothChecked || saving} data-testid="accept-privacy-btn"
            className="w-full bg-[#C9A84C] text-[#001830] hover:bg-[#C9A84C]/90 h-11 font-semibold disabled:opacity-30">
            {saving ? "Registrazione consenso..." : <><CheckCircle className="w-4 h-4 mr-2" /> Accetto e Prosegui</>}
          </Button>
        </div>

        <p className="text-center text-[9px] text-white/20 mt-4">Il consenso viene registrato e può essere revocato in qualsiasi momento</p>
      </div>
    </div>
  );
}
